<template>
    <div class="card modal-card">
      <div class="modal-card-body pd-0">
        <header class="bandeau-modal card-header">
        </header>
        <div class="center">
          <div class="columns is-gapless">
            <div class="column mgt-20px">
              <h1 class="title is-size-3">{{ $t('listeIntervention.demandeEnfant.title')}}</h1>
            </div>
          </div>
        </div>
        <div class="card-content">
          <v-client-table :data=demandesInterventionEnfant :columns="columns" :options="options"
                          ref="tableDemandeInterventionEnfant"
                          class="mgt-20px">
            <div slot="creationTime" slot-scope="props">
              {{ getDate(props.row.creationTime) }}
            </div>
            <div slot="demandeur" slot-scope="props">
              {{ getUser(props.row.demandeurId) }}
            </div>
            <div slot="etat" slot-scope="props">
              {{ $t(getEtat(props.row.etat)) }}
            </div>
            <div slot="otLie" slot-scope="props">
              <router-link-blank :to="{ name: 'c.logistique.ordre_travail-tech',
        params: { id: props.row.otTechnique.id } }"
                                 v-if="props.row.otTechnique"
                                 :message="props.row.otTechnique.code"
                                 typeIcon="is-primary" sizeIcon="is-small">
              </router-link-blank>
            </div>
          </v-client-table>
          <div class="mgb-40px">
            <b-field>
              <div class="is-pulled-left boutonAction">
                <a class="button" @click="$parent.close()">
                  {{ $t('general.button.close') }}
                </a>
              </div>
            </b-field>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import {
  NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import formatDate from '@/services/general/formatDate';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { ETAT_DEMANDE_INTERVENTION, ETAT_NOUVEAU } from '@/configuration/logistique/intervention/interventionConf';
import cloneDeep from 'lodash/cloneDeep';
import routerLinkBlank from '@/components/general/routerLinkBlank';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'p_interventionFusion',
  props: {
    demandesInterventionEnfant: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      etatsIntervention: ETAT_DEMANDE_INTERVENTION,
      newStateDemande: ETAT_NOUVEAU,
    };
  },
  components: {
    routerLinkBlank,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getDate(date) {
      return formatDate(date);
    },
    getUser(userId) {
      const userFind = this.parametre(PARAMETRES_KEYS.utilisateur).find((user) => {
        return user.id === userId;
      });
      return userFind ? userFind.decorator.nomPrenom : '';
    },
    getEtat(etatDemande) {
      const etatFind = this.etatsIntervention.find((etat) => {
        return etat.key === etatDemande;
      });
      if (!etatFind) return null;
      return etatFind.libelle;
    },
    getEtatInformation(key) {
      return this.etatsIntervention.find((etat) => {
        return etat.key === key;
      });
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    columns() {
      return ['code', 'creationTime', 'actionLogistique', 'demandeur', 'etat', 'otLie'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          etat: this.$t('listeIntervention.fusion.tab.etat'),
          code: this.$t('listeIntervention.fusion.tab.nDemande'),
          creationTime: this.$t('listeIntervention.fusion.tab.date'),
          actionLogistique: this.$t('listeIntervention.fusion.tab.sujetDemande'),
          demandeur: this.$t('listeIntervention.fusion.tab.demandeur'),
          otLie: this.$t('listeIntervention.fusion.tab.otLie'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        texts: texts,
        columnsClasses: {
          selected: 'colonneSelected',
        },
        sortable: ['libelle'],
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
